import { getProduct } from '@/utils/products';

export const formattedTitle = ({ title, referralUser, userName }) => {
  if (referralUser) {
    let formattedTitle = title;
    formattedTitle = formattedTitle.replace(
      'USER_NAME',
      `<b>${referralUser.inviter_first_name}</b>`,
    );
    const product = getProduct({ productKey: referralUser.unit });
    formattedTitle = formattedTitle.replace('PRODUCT', product?.name);
    return formattedTitle;
  }
  if (userName?.length) {
    return title?.replace(/{{USER_NAME}}|{NAME}/, userName);
  }
  if (!userName && title.includes('{{USER_NAME}}')) {
    const PREFIX_RE = /^(?:<strong>)?\s*\{\{USER_NAME}},\s*(?:<\/strong>)?\s*/i;

    let titleWithoutUsername = title.replace(PREFIX_RE, '');

    return titleWithoutUsername.charAt(0).toUpperCase() + titleWithoutUsername.slice(1);
  }

  if (!userName && title.includes('{NAME}')) {
    const titleWithoutUsername = title
      .trim()
      .substring('{{NAME}}'.length)
      .replace(/,/g, ' ')
      .trim();
    return titleWithoutUsername.charAt(0).toUpperCase() + titleWithoutUsername.slice(1);
  }

  return title;
};
